<template>
  <div class="central-box">
    <div class="central">
      <div>
        <div class="central-yunnan">
          <div class="central-yunnan-title">
            <span style="max-width: 40%">{{ name }}</span>
          </div>
        </div>
      </div>
      <yunnan :listArea="listArea"></yunnan>
      <economic :landList="landList"></economic>
      <area-main :listArea="listArea" :editId="editId"></area-main>
      <!--  回到顶部  -->
      <!-- <div class="regular-content">
          <div class="regular-content-item">
            <i class="el-icon-s-order icon-color"></i>
          </div>
          <div class="regular-content-item">
            <i class="el-icon-phone icon-color"></i>
          </div>
          <div class="regular-content-item" @click="toTop">
            <img
              style="width: 20px"
              :src="require('@/assets/images/tools/fanhuidingbu.png')"
              alt=""
            />
          </div>
        </div> -->
    </div>

    <div class="app-foot central-foot">
      <div class="app-foot-item">
        <router-link to="/555" tag="span" class="app-foot-item-text">
          网站地图
        </router-link>
        |
        <router-link to="/555" tag="span" class="app-foot-item-text">
          联系我们
        </router-link>
        |
        <router-link to="/555" tag="span" class="app-foot-item-text">
          网站纠错
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import yunnan from "@/components/centralYunnan/yunnan.vue";
import economic from "@/components/centralYunnan/economic.vue";
import areaMain from "@/components/centralYunnan/areaMain.vue";
import listMain from "@/components/centralYunnan/listMain.vue";
import { newPromotionEdit, getRecommendDkList } from "@/api/common";
export default {
  name: "centralYunnan",
  components: {
    yunnan,
    economic,
    areaMain,
    listMain,
  },
  // props:['landList','listArea','name'],
  data() {
    return {
      areaData: ["空港经济区", "嵩明片区", "安宁片区"],
      tabPosition: "空港经济区",
      listTabsData: [
        "小哨国际新城",
        "东盟产业城",
        "空港商务区",
        "临空产业园",
        "杉松园长水航城片区",
      ],
      navigationIndex: 0,
      page: 1,
      rows: 9,
      total: 24,
      name: "",
      landList: "",
      listArea: "",
      editId: null,
    };
  },
  mounted() {
    this.editId = this.$route.query.id;
    this.newPromotionEdit();
  },
  methods: {
    // 获取数据
    newPromotionEdit() {
      // let data={
      //   tjzcId:this.editId
      // }
      // getRecommendDkList(data).then((res)=>{
      //       if (res.data.success) {
      //     let data = res.data.data;
      //     this.name = data.name;
      //     this.landList = data.landList;
      //     this.listArea = data.listArea;
      //   }
      // })
      newPromotionEdit(this.editId).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          this.name = data.name;
          this.landList = data.landList;
          this.listArea = data.listArea;
        }
      });
    },
    changeTheme(val) {
      console.log(val);
    },
    navigationSelect(index) {
      this.navigationIndex = index;
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      this.rows = newSize;
      // this.getDataList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      this.page = newPage;
      // this.getDataList()
    },
    //回到顶部
    toTop() {
      this.$nextTick(() => {
        // let app = document.getElementById("app");
        // console.log(app.scrollTop, "===");
        // app.scrollTop = 0;
        let app = document.getElementsByClassName("central-yunnan")[0];
        console.log(app);
        console.log(app.scrollTop);
        let top = app.scrollTop;
        const timeTop = setInterval(() => {
          app.scrollTop = app.scrollTop = top -= 10;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      });
    },
  },
};
</script>

<style scoped>
html,
body,
#app {
  height: 100%;
  background: #fff !important;
}
p {
  padding: 0;
  margin: 0;
}
.central-box {
  /*height: 100%;*/
  background: #fff;
}
.central {
  width: 100%;
  height: 100%;
  background: #fff !important;
}

.central-yunnan {
  /* min-height: calc(100% - 40px); */
  /* display: inline-table; */
  width: 100%;
  /* overflow: auto; */
  margin: 0 auto;
  /*overflow-x: hidden;*/
}
.central-yunnan-title {
  background-image: url("~@/assets/promotion/titleImg01.png");
  background-size: 100% 100%;
  /*background: linear-gradient(160deg, rgba(63,77,201,.8), rgba(102,180,213,.4));*/
  height: 250px;
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 4px;
  font-style: italic;
}

/*单选按钮 选中的样式*/
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #386ed6;
  border-color: #386ed6;
}

.list-tabs-content {
  width: 40%;
  margin: 20px auto auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}
.list-tabs-item {
  border-radius: 20px;
  border: 1px solid #8cabe7;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  font-size: 0.85rem;
  color: #333333;
  cursor: pointer;
}
/deep/ .el-pagination button:disabled {
  background: #386ed6;
  color: #ffffff;
  border-radius: 2px;
}
/deep/ .el-pagination {
  background: #ffffff !important;
}
/deep/ .el-pager li.active {
  border: none;
  border-radius: 0;
  background: #386ed6;
  color: #ffffff;
}
/deep/ .el-pager li {
  border: 1px solid #386ed6;
  color: #386ed6;
  margin-right: 10px;
}
/deep/ .el-pager li:nth-child(1) {
  margin-left: 10px;
}
/deep/ .el-pager li.active + li {
  border: 1px solid #386ed6;
}
.regular-content {
  position: fixed;
  bottom: 100px;
  right: calc(10% - 10px);
}
.regular-content-item {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  margin-top: 20px;
  line-height: 40px;
  box-shadow: inset 0 0 5px rgb(63 77 201 / 10%),
    0 0 10px rgb(140 141 140 / 60%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-color {
  color: #386ed6;
  font-size: 1.12rem;
}
</style>
